import React, { Fragment } from "react";
import Loadable from "react-loadable";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import createHistory from "history/createBrowserHistory";
import { Switch } from "react-router-dom";
import { Router } from "react-router";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import ReduxToastr from "react-redux-toastr";
import ReactTooltip from "react-tooltip";

import ModalsRoot from "components/globalModals";

import reducers from "ducks/index";
import { authInitWorker } from "ducks/auth/actions";
import { ErrorBoundary, Loader, ScrollTop } from "components";
import { AnimRoute, AuthRoute } from "components/routes";
import { Error404, RouteListener } from "partialComponents";

import Login from "pages/login/Login";
import Logout from "pages/logout/Logout";
import PasswordReset from "pages/password/Reset";
import PasswordConfirm from "pages/password/confirm";

export const history = createHistory();
const middleware = [thunk, routerMiddleware(history)];
let devtools;
let composedMiddleware;
if (process.env.NODE_ENV === "production" || !window.__REDUX_DEVTOOLS_EXTENSION__) {
  composedMiddleware = applyMiddleware(...middleware);
} else {
  devtools = window.__REDUX_DEVTOOLS_EXTENSION__();
  composedMiddleware = compose(
    applyMiddleware(...middleware),
    devtools
  );
}

const store = createStore(reducers, composedMiddleware);

const loader = () => <Loader absolute={true} large={true} />;

const Content = Loadable({
  loader: () => import("routeContainers/Content"),
  loading: loader,
});

class App extends React.Component<any> {
  componentDidMount() {
    store.dispatch(authInitWorker());
  }

  render() {
    return (
      <Provider store={store}>
        <React.Fragment>
          <Router history={history}>
            <Fragment>
              <ErrorBoundary>
                <RouteListener />
                <Switch>
                  <AnimRoute exact path="/login" component={Login} />
                  <AnimRoute exact path="/logout" component={Logout} />
                  <AnimRoute exact path="/password/reset" component={PasswordReset} />
                  <AnimRoute
                    exact
                    path="/password/confirm/:uid/:token"
                    component={PasswordConfirm}
                  />
                  {/* required authentication; container */}
                  <AuthRoute path="/" component={Content} />
                  <AnimRoute path="*" component={Error404} />
                </Switch>
                <ModalsRoot />
              </ErrorBoundary>
              <ReduxToastr
                timeOut={6000}
                newestOnTop={false}
                preventDuplicates={false}
                position="top-center"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
              />
            </Fragment>
          </Router>
          <ReactTooltip effect="solid" />
          <ScrollTop />
          <div style={{ fontFamily: "Barlow", fontWeight: 500, fontStyle: "italic" }}> </div>{" "}
          {/* font preload to avoid layout jumping */}
        </React.Fragment>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js